import React from "react";

function Tel() {
  const phoneNUmber = "+233246375367";

  return <a href={`tel:${phoneNUmber}`}>233 - 2463 - 75367</a>;
}

export default Tel;
